export const API_URL = getURL();
function getURL() {
  if (window.location.origin.match(/[http|https]:\/\/localhost:8200/g)) {
    return process.env.REACT_APP_API_URL;
  }
  if (window.location.origin.match(/[http|https]:\/\/localhost:8100/g)) {
    return process.env.REACT_APP_API_URL;
  } else if (
    window.location.origin === "http://192.168.0.96:8100" ||
    window.location.origin === "https://192.168.0.96:443"
  ) {
    return process.env.REACT_APP_API_URL_TEST;
  } else if (window.location.origin === "https://dev-app.proactivestrides.com")
    return process.env.REACT_APP_API_URL_DEV;
  else if (window.location.origin === "https://test-app.proactivestrides.com")
    return process.env.REACT_APP_API_URL_TEST;
  else if (window.location.origin === "https://demo-app.proactivestrides.com")
    return process.env.REACT_APP_API_URL_DEMO;
  else if (window.location.origin === "https://app.proactivestrides.com")
    return process.env.REACT_APP_API_URL_PROD;
  else if (
    window.location.origin === "https://performance-app.proactivestrides.com"
  )
    return process.env.REACT_APP_API_URL_DEMO_PER;
  return process.env.REACT_APP_API_URL_DEV;
}
